var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card bg-header"},[_c('h2',{staticClass:"card-header"},[_vm._v("Kontostand")]),_c('span',{staticClass:"text-center fs-3 py-2"},[_c('ProjectBalance',{attrs:{"project-id":_vm.project.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }